import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  useTransition,
  animated,
} from 'react-spring';
import { useIntl } from 'react-intl';

const UploadDropOverlay = ({ show, collectionUuid, uploadModal }) => {
  const intl = useIntl();

  const transitions = useTransition(show, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  return transitions.map(({ item, key, props }) => item && (
    <animated.div className="upload-drop-overlay" key={key} style={props}>
      <div className="upload-drop-overlay-content">
        <h1>
          {
            (collectionUuid && !uploadModal) ?
              intl.formatMessage({ defaultMessage: 'Drop files to upload to this Collection' }) :
              intl.formatMessage({ defaultMessage: 'Drop files to upload' })
          }
          <br /><i className="fas fa-upload" />
        </h1>
      </div>
    </animated.div>
  ));
};

const mapStateToProps = state => ({
  collectionUuid: state.Files.collectionUuid,
  uploadModal: state.Files.uploadModal,
});

UploadDropOverlay.propTypes = {
  collectionUuid: PropTypes.string,
  uploadModal: PropTypes.bool.isRequired,
  show: PropTypes.bool,
};

UploadDropOverlay.defaultProps = {
  collectionUuid: null,
  show: true,
};

export default connect(mapStateToProps)(UploadDropOverlay);
